// ============================================================================
// AVL TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'avl-tree',
  name: 'AVL Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A self-balancing binary search tree where the heights of the two child subtrees of any node differ by at most one. Maintains balance through rotations after insertions and deletions, guaranteeing O(log N) operations.'
};
